import React from "react";
import { Link } from "gatsby";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import Moment from "@/components/MomentAdapter";
import "dayjs/locale/pl";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.locale("pl");

const MatchesCard = ({ data }) => {
  const {
    type,
    url,
    statusName,
    name,
    processedName,
    tags,
    categories,
    bannerImage,
    publishDate,
  } = data;

  const localPublishDate = dayjs.utc(publishDate).local();

  if (type == "sponsor") {
    return (
      <a href={url} target="_blank" rel="noreferrer">
        <div className="singleTM card-container text-start card-sponsor-container">
          <div
            className="tm_img"
            style={{ backgroundImage: `url('${bannerImage}')` }}
          >
            <div className="tm_overlay" />
          </div>
        </div>
      </a>
    );
  }
  return (
    <Link to={`/${!type ? "jagatv" : "aktualnosci"}/${processedName}`}>
      <div className="singleTM card-container text-start">
        <div
          className="tm_img"
          style={{ backgroundImage: `url('${bannerImage}')` }}
        >
          <div className="tm_overlay" />
          <div className="detail_TM">
            {/* <div className="team_social">
                {tags
                  .toString()
                  .split(",")
                  .map((tag, index) => (
                    <a key={index} href="#">
                      <span>{tag}</span>
                    </a>
                  ))}
              </div> */}
            <h5>{name}</h5>
            <h6>
              <span className="text-white me-2">
                <Moment date={localPublishDate} format="DD.MM.YYYY" />
              </span>
              <span>
                <Moment date={localPublishDate} format="HH:mm" />
              </span>
            </h6>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default MatchesCard;
